var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "theme-code-group"
  }, [_c('div', {
    staticClass: "theme-code-group__nav"
  }, [_c('ul', {
    staticClass: "theme-code-group__ul"
  }, _vm._l(_vm.codeTabs, function (tab, i) {
    return _c('li', {
      key: tab.title,
      staticClass: "theme-code-group__li"
    }, [_c('button', {
      staticClass: "theme-code-group__nav-tab",
      class: {
        'theme-code-group__nav-tab-active': i === _vm.activeCodeTabIndex
      },
      on: {
        "click": function ($event) {
          return _vm.changeCodeTab(i);
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])]);
  }), 0)]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _vm.codeTabs.length < 1 ? _c('pre', {
    staticClass: "pre-blank"
  }, [_vm._v("// Make sure to add code blocks to your code group")]) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };